module.exports = ":host .invoice-blocks {\n  font-size: 11px;\n  padding: 1px 0;\n  margin: 0; }\n\n:host .table-payments.table tbody > tr > td {\n  height: 65px !important; }\n\n:host .payment-warning {\n  background-color: #f35d5d; }\n\n:host .payment-primary {\n  background-color: #999999; }\n\n:host .payment-success {\n  background-color: #91c847; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/payments/payments-overview/payments-overview.component.scss
// module id = ./web/modern/components/payments/payments-overview/payments-overview.component.scss
// module chunks = 0